import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { UpdateSuggestionDiscountSettingsPayload } from "../../recommendation.types";
import { requestUpdateSuggestionDiscountSettings } from "./updateSuggestionDiscountSettings.request";

const useUpdateSuggestionDiscountSettings = (
  options?: MutationOptions<
    void,
    ApiServiceError<ApiError>,
    UpdateSuggestionDiscountSettingsPayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestUpdateSuggestionDiscountSettings,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["recommendation", "suggestionDiscount"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useUpdateSuggestionDiscountSettings;
